<!--
  Una CENTRAL vacía se ve IGUAL que un mes sin facturas. El aviso va primero y sin poder cerrarse:
  sin él, «no se facturó nada» y «nadie subió la hoja» son la misma pantalla.
-->
<div class="ct-alert" *ngIf="watch?.missing">
  <i class="fa-solid fa-triangle-exclamation"></i>
  <span>{{ watch?.message }}</span>
  <!-- El aviso pide subir la hoja: el botón para hacerlo va en el mismo renglón que lo pide. -->
  <button
    *ngIf="puedeImportar"
    pButton
    type="button"
    class="p-button-sm ct-alert-cta"
    icon="fa-solid fa-file-arrow-up"
    label="Importar hoja CENTRAL"
    (click)="abrirImportar()"
  ></button>
</div>

<!--
  El cuadre de rentas: lo capturado en la hoja contra lo que dice el CFDI.

  Va arriba de las tablas y siempre visible porque responde si lo de abajo es de fiar. Cerrado
  ocupa un renglón; se abre solo cuando hay algo que mirar. El detalle empieza por lo que difiere:
  una lista que arranca con cincuenta filas que cuadran esconde las tres que no.
-->
<div class="ct-cuadre" *ngIf="cuadre" [class.is-off]="(cuadre.totals.differing || 0) > 0">
  <!-- El botón va FUERA del toggle: un `button` dentro de otro `button` no es HTML válido. -->
  <button
    *ngIf="cuadre.totals.rows"
    pButton
    type="button"
    class="p-button-sm p-button-text ct-cuadre-exp"
    icon="fa-solid fa-file-excel"
    label="Exportar"
    pTooltip="Bájalo como lista de trabajo: lo que hay que corregir va arriba"
    tooltipPosition="left"
    [loading]="exportandoCuadre"
    (click)="exportarCuadre($event)"
  ></button>

  <button type="button" class="ct-cuadre-head" (click)="cuadreAbierto = !cuadreAbierto" [attr.aria-expanded]="cuadreAbierto">
    <i class="fa-solid" [ngClass]="cuadreAbierto ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
    <span class="ct-cuadre-ttl">Cuadre de rentas</span>
    <span class="ct-cuadre-pct">{{ cuadrePct }}</span>
    <!--
      «0 de 0 comparables» no se entendía: es que no hay ni una factura con los DOS lados —la hoja y el
      XML—. Se dice qué falta en vez de un conteo en ceros.
    -->
    <span class="ct-cuadre-sub" *ngIf="!cuadre.totals.comparable"
      >Sin datos para comparar: hace falta la hoja CENTRAL del mes y el XML de cada factura</span
    >
    <span class="ct-cuadre-sub" *ngIf="cuadre.totals.comparable">
      <b>{{ cuadre.totals.matched }}</b> de <b>{{ cuadre.totals.comparable }}</b> comparables cuadran
      <ng-container *ngIf="cuadre.totals.differing">
        · <b class="ct-pend">{{ cuadre.totals.differing }}</b> difieren por
        <b class="ct-pend">{{ cuadre.totals.differenceTotal | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b>
      </ng-container>
      <ng-container *ngIf="cuadre.totals.missingCfdi"> · {{ cuadre.totals.missingCfdi }} sin CFDI</ng-container>
      <ng-container *ngIf="cuadre.totals.missingSheet"> · {{ cuadre.totals.missingSheet }} sin captura</ng-container>
    </span>
  </button>

  <div class="ct-cuadre-body" *ngIf="cuadreAbierto">
    <!-- Las salvedades vienen del servidor y se pintan enteras: dicen de qué NO habla este control. -->
    <ul class="ct-cuadre-caveats" *ngIf="cuadre.caveats?.length">
      <li *ngFor="let c of cuadre.caveats">{{ c }}</li>
    </ul>

    <p class="ct-nodeps" *ngIf="!cuadreFilas.length">No hay facturas que comparar en este mes.</p>

    <div class="ct-scroll" *ngIf="cuadreFilas.length">
      <table class="ct-table">
        <thead>
          <tr>
            <th>Folio fiscal</th>
            <th>Clasificación</th>
            <th class="ct-num">Capturado en la hoja</th>
            <th class="ct-num">Total del CFDI</th>
            <th class="ct-num">Diferencia</th>
            <th>Veredicto</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of cuadreFilas">
            <td class="ct-mono">{{ f.folioFiscal }}</td>
            <td>{{ etiquetaClasificacion(f.classification) }}</td>
            <!-- `null` no es cero: es que ese lado no existe. Un $0.00 diría que se capturó en cero. -->
            <td class="ct-num">{{ f.sheetTotal == null ? '—' : (f.sheetTotal | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}</td>
            <td class="ct-num">{{ f.cfdiTotal == null ? '—' : (f.cfdiTotal | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}</td>
            <td class="ct-num" [class.ct-pend]="f.difference">
              {{ f.difference == null ? '—' : (f.difference | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}
            </td>
            <td><p-tag [severity]="veredicto(f.verdict).sev" [value]="veredicto(f.verdict).label"></p-tag></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="ct-bar">
  <div class="ct-tabs" role="tablist">
    <button
      *ngFor="let t of tables"
      type="button"
      role="tab"
      class="ct-tab"
      [class.is-act]="tabla === t.key"
      [attr.aria-selected]="tabla === t.key"
      [pTooltip]="t.hint"
      tooltipPosition="bottom"
      (click)="tabla = t.key; abierto = null"
    >
      {{ t.label }} <span class="ct-count">{{ cuantas(t.key) }}</span>
    </button>
  </div>

  <div class="ct-actions">
    <span class="ct-totals" *ngIf="central">
      Facturado <b>{{ central.totals.invoiced | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b> · Cobrado
      <b>{{ central.totals.collected | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b> · Falta
      <b class="ct-pend">{{ central.totals.pending | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b>
      <ng-container *ngIf="central.totals.collectedInMonth">
        · Entró en el mes <b class="ct-ok">{{ central.totals.collectedInMonth | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b>
      </ng-container>
    </span>
    <button
      *ngIf="puedeImportar"
      pButton
      type="button"
      class="p-button-sm p-button-outlined"
      icon="fa-solid fa-file-arrow-up"
      label="Importar hoja CENTRAL"
      (click)="abrirImportar()"
    ></button>
    <button
      pButton
      type="button"
      class="p-button-sm p-button-outlined"
      icon="fa-solid fa-file-excel"
      label="Exportar"
      [disabled]="!central || exportando"
      [loading]="exportando"
      (click)="exportar()"
    ></button>
  </div>
</div>

<!-- Esqueleto con la geometría de la tabla: al llegar las filas nada salta de sitio. -->
<div class="ct-skeleton" *ngIf="loading">
  <p-skeleton height="2.2rem" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]" styleClass="mb-2"></p-skeleton>
</div>

<ng-container *ngIf="!loading">
  <!-- Vacío con causa: el mensaje cambia según SEPAMOS por qué no hay nada. -->
  <div class="ct-empty" *ngIf="!filas.length">
    <i class="fa-solid fa-table-list"></i>
    <p *ngIf="watch?.missing">No hay nada que mostrar porque la hoja del mes no se ha subido.</p>
    <p *ngIf="!watch?.missing">No hay facturas en «{{ etiquetaTabla }}» para este mes.</p>
  </div>

  <div class="ct-scroll" *ngIf="filas.length">
    <table class="ct-table">
      <thead>
        <tr>
          <th class="ct-w-40"></th>
          <th>Folio fiscal</th>
          <th>Contrato</th>
          <th>Cliente</th>
          <th class="ct-num" *ngFor="let c of conceptosUsados">{{ c.label }}</th>
          <th class="ct-num">Subtotal</th>
          <th class="ct-num">IVA</th>
          <th class="ct-num">Total</th>
          <!--
            De dónde sale esta cifra NO es evidente y cambia según el rubro. Es la que Contabilidad
            contrasta contra su hoja, así que la conversación tiene que ser sobre la definición.
          -->
          <th class="ct-num">
            Cobrado
            <app-ayuda-cifra titulo="De dónde sale «Cobrado»">
              <p>Depende de lo que sea la factura, y por eso no siempre viene del mismo sitio:</p>
              <ul>
                <li>
                  <b>Rentas, enganches y residuales</b> — de las <b>aplicaciones de pago</b>: el dinero que ya se aplicó contra la letra a
                  la que está anclada la factura. Manda el libro de pagos.
                </li>
                <li>
                  <b>Gestoría, seguros y otras</b> — de los <b>depósitos capturados</b> en el renglón: la plataforma no concilia solas esas
                  facturas, así que ese cobro no existe en ningún otro lado.
                </li>
              </ul>
              <p>Abre el renglón con la flecha y cada depósito dice de cuál de los dos vino.</p>
              <p class="ay-ojo">
                La <b>mora cobrada no cuenta</b> aquí: no se factura con la renta, y sumarla haría parecer la factura más cobrada de lo que
                está.
              </p>
            </app-ayuda-cifra>
          </th>
          <th class="ct-num">Falta</th>
          <th>Clasificación</th>
          <th>Vence</th>
          <th>Estatus</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let f of filas">
          <tr class="ct-row" [class.is-open]="abierto === f.invoiceId" (click)="abrir(f)">
            <td class="ct-w-40">
              <i
                class="fa-solid"
                [ngClass]="abierto === f.invoiceId ? 'fa-chevron-down' : 'fa-chevron-right'"
                *ngIf="f.deposits?.length"
              ></i>
            </td>
            <td class="ct-mono">{{ f.folioFiscal }}</td>
            <td>{{ f.contractNumber || f.leaseFolio }}</td>
            <td class="ct-client">{{ f.clientName || '—' }}</td>
            <td class="ct-num" *ngFor="let c of conceptosUsados">
              {{ monto(f, c.key) ? (monto(f, c.key) | currency: 'MXN' : 'symbol-narrow' : '1.2-2') : '—' }}
            </td>
            <!--
              Una factura sin XML no tiene subtotal, IVA ni total. Sin el «—» las tres celdas salen
              EN BLANCO y la fila parece rota, cuando lo que pasa es que falta el CFDI — que es
              justamente lo que el cuadre necesita que se note.
            -->
            <td class="ct-num">{{ f.subtotal == null ? '—' : (f.subtotal | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}</td>
            <td class="ct-num">{{ f.iva == null ? '—' : (f.iva | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}</td>
            <td class="ct-num ct-strong">{{ f.total == null ? '—' : (f.total | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}</td>
            <td class="ct-num">{{ f.collected | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
            <!--
              Un «falta» NEGATIVO es una contradicción a la vista y se lee como un error del reporte.
              Cuando entró MÁS de lo que dice la factura —la letra recibió más de lo facturado— el
              dato importa y no se esconde: se dice lo que es, «sobra», con su importe en positivo.
            -->
            <td class="ct-num" [class.ct-pend]="f.pending > 0" [class.ct-over]="f.pending < 0">
              <ng-container *ngIf="f.pending >= 0">{{ f.pending | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</ng-container>
              <ng-container *ngIf="f.pending < 0">sobra {{ -f.pending | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</ng-container>
            </td>
            <td class="ct-class" [class.is-none]="!f.classification || f.classification === 'UNCLASSIFIED'">
              {{ etiquetaClasificacion(f.classification) }}
            </td>
            <td>{{ f.dueDate ? (f.dueDate | date: 'dd/MM/yy' : 'UTC') : '—' }}</td>
            <td>
              <p-tag [severity]="severidad(f.collectionStatus)" [value]="etiqueta(f.collectionStatus)"></p-tag>
              <!-- El atraso solo se dice cuando lo hay: un «0 días» en cada fila es ruido. -->
              <small class="ct-late" *ngIf="f.daysOverdue && f.daysOverdue > 0">{{ f.daysOverdue }} d</small>
              <!--
                Pagada por la conciliación, pero «Cobrado» no llega al total: el resto se cobró antes de
                que existieran las aplicaciones (contratos migrados). Se dice, para que la resta
                Total − Cobrado no se lea como un saldo pendiente.
              -->
              <small
                class="ct-trail"
                *ngIf="f.paidWithoutFullTrail"
                pTooltip="La letra está pagada. «Cobrado» solo suma los depósitos registrados en la plataforma; el resto se cobró antes de que existieran."
                tooltipPosition="left"
                >pagada · rastro parcial</small
              >
              <!-- Solo en las de un mes anterior: si se cobró en ESTE mes o sigue arrastrándose. -->
              <small class="ct-arrears is-in" *ngIf="f.arrearsState === 'COLLECTED_IN_MONTH'">Cobrada en el mes</small>
              <small class="ct-arrears is-open" *ngIf="f.arrearsState === 'STILL_OPEN'">
                Sigue pendiente<ng-container *ngIf="f.collectedInMonth"> · abono en el mes</ng-container>
              </small>
            </td>
          </tr>

          <!--
            Los depósitos del renglón. `SHEET` se marca aparte a propósito: para gestoría y «otros» la
            plataforma no concilia sola, así que ese dato viene de la captura de Contabilidad y no del
            libro de pagos. Presentarlos igual haría pasar una captura por una aplicación.
          -->
          <tr class="ct-detail" *ngIf="abierto === f.invoiceId">
            <td [attr.colspan]="12 + conceptosUsados.length">
              <!-- Las notas de Contabilidad del renglón: la columna NOTAS de su hoja. -->
              <p class="ct-notes" *ngIf="f.notes"><i class="fa-regular fa-note-sticky"></i> {{ f.notes }}</p>
              <div class="ct-deps" *ngIf="f.deposits?.length">
                <div class="ct-dep" *ngFor="let d of f.deposits">
                  <span class="ct-dep-amt">{{ d.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
                  <span>{{ d.paidAt ? (d.paidAt | date: 'dd/MM/yy' : 'UTC') : 'sin fecha' }}</span>
                  <span>{{ d.bank || 'banco no dicho' }}</span>
                  <span class="ct-mono">{{ d.reference || 'sin referencia' }}</span>
                  <p-tag
                    [severity]="d.source === 'LEDGER' ? 'success' : 'warning'"
                    [value]="d.source === 'LEDGER' ? 'del libro de pagos' : 'capturado en la hoja'"
                  ></p-tag>
                  <!--
                    Solo se puede quitar lo CAPTURADO. Un depósito del libro de pagos se corrige en el
                    pago, con su bitácora y su prelación: borrarlo desde aquí lo dejaría fuera de las
                    dos cuentas.
                  -->
                  <button
                    *ngIf="puedeCapturar && d.source === 'SHEET' && d.id"
                    pButton
                    type="button"
                    icon="fa-solid fa-xmark"
                    class="p-button-sm p-button-text p-button-danger"
                    pTooltip="Quitar este depósito capturado"
                    (click)="quitarDeposito(f, d.id, $event)"
                  ></button>
                </div>
              </div>

              <p class="ct-nodeps" *ngIf="!f.deposits?.length">Sin depósitos registrados.</p>

              <!--
                Lo que Contabilidad captura a mano y su hoja sí tiene: la clasificación, el mes
                contable y los depósitos que la plataforma no concilia sola. Es lo que les permite
                dejar de llenar el Excel.
              -->
              <div class="ct-capture" *ngIf="puedeCapturar">
                <button
                  pButton
                  type="button"
                  icon="fa-solid fa-pen"
                  label="Corregir clasificación, mes o notas"
                  class="p-button-sm p-button-text"
                  (click)="abrirCorreccion(f, $event)"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="fa-solid fa-money-bill-wave"
                  label="Registrar depósito"
                  class="p-button-sm p-button-text"
                  (click)="abrirDeposito(f, $event)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- ── Corregir lo que Contabilidad captura ─────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarCorreccion"
  [modal]="true"
  [closable]="!guardando"
  header="Corregir la factura"
  styleClass="central-fix-dialog"
  [style]="{ width: '520px' }"
  (onHide)="editando = null"
>
  <div class="ct-form" *ngIf="editando">
    <p class="ct-form-lead">
      <b>{{ editando.folioFiscal }}</b> · {{ editando.clientName || editando.leaseFolio }}
    </p>

    <label for="ct-class">Clasificación</label>
    <select id="ct-class" [(ngModel)]="edClasificacion">
      <option value="">— sin cambiar —</option>
      <option *ngFor="let c of clasificaciones" [value]="c.key">{{ c.label }}</option>
    </select>
    <!--
      Las columnas del desglose salen del CFDI, no de aquí, y no se mueven con este campo: una
      factura de renta + GPS reparte su dinero en dos columnas aunque la fila entera se llame RENTA.
      Sin decirlo, quien clasifica una fila desde la columna «Sin clasificar» la ve seguir ahí y
      vuelve a clasificarla, porque no hay nada en la pantalla que explique por qué no se movió.
    -->
    <small class="ct-form-hint"> Es la etiqueta de la fila. Las columnas del desglose vienen del CFDI y no cambian con esto. </small>

    <label for="ct-mes">Mes contable</label>
    <input id="ct-mes" pInputText [(ngModel)]="edMes" placeholder="AAAA-MM" autocomplete="off" />
    <!-- El caso que obliga a que esto sea editable, dicho donde se edita. -->
    <small class="ct-form-hint"> No siempre es el mes de la factura: una renta de agosto puede facturarse en septiembre. </small>

    <label for="ct-notas">Notas <span class="ct-opt">(la columna NOTAS de su hoja)</span></label>
    <textarea
      id="ct-notas"
      pInputTextarea
      rows="2"
      maxlength="1000"
      [(ngModel)]="edNotas"
      placeholder="Ej.: pagó con dos transferencias"
    ></textarea>

    <label for="ct-motivo">Motivo <span class="ct-opt">(opcional, queda en la bitácora)</span></label>
    <input id="ct-motivo" pInputText [(ngModel)]="edMotivo" autocomplete="off" />

    <small class="ct-form-error" *ngIf="problemaCorreccion && !edError">{{ problemaCorreccion }}</small>
    <div class="ct-form-alert" *ngIf="edError" role="alert"><i class="fa-solid fa-circle-exclamation"></i> {{ edError }}</div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      [disabled]="guardando"
      (click)="mostrarCorreccion = false"
    ></button>
    <button
      pButton
      type="button"
      label="Guardar"
      icon="fa-solid fa-check"
      [loading]="guardando"
      [disabled]="guardando || !!problemaCorreccion"
      (click)="guardarCorreccion()"
    ></button>
  </ng-template>
</p-dialog>

<!-- ── Registrar un depósito capturado ──────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarDeposito"
  [modal]="true"
  [closable]="!guardando"
  header="Registrar un depósito"
  styleClass="central-deposit-dialog"
  [style]="{ width: '520px' }"
  (onHide)="depositando = null"
>
  <div class="ct-form" *ngIf="depositando">
    <p class="ct-form-lead">
      <b>{{ depositando.folioFiscal }}</b> · falta
      <b>{{ depositando.pending | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b>
    </p>
    <p class="ct-form-note">
      Para la renta, el enganche y el residual manda el libro de pagos. Esto es el respaldo de lo que la plataforma <b>no concilia sola</b>:
      gestoría y otros.
    </p>

    <label for="ct-monto">Monto</label>
    <input id="ct-monto" type="number" pInputText [(ngModel)]="depMonto" autocomplete="off" />

    <label for="ct-fecha">Fecha del depósito</label>
    <input id="ct-fecha" type="date" pInputText [(ngModel)]="depFecha" autocomplete="off" />

    <label for="ct-banco">Banco <span class="ct-opt">(opcional)</span></label>
    <input id="ct-banco" pInputText [(ngModel)]="depBanco" autocomplete="off" />

    <label for="ct-ref">Referencia <span class="ct-opt">(opcional)</span></label>
    <input id="ct-ref" pInputText [(ngModel)]="depReferencia" autocomplete="off" />
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="guardando" (click)="mostrarDeposito = false"></button>
    <button
      pButton
      type="button"
      label="Registrar"
      icon="fa-solid fa-check"
      [loading]="guardando"
      [disabled]="guardando || !depMonto || depMonto <= 0"
      (click)="guardarDeposito()"
    ></button>
  </ng-template>
</p-dialog>

<!-- ── Importar la hoja CENTRAL ──────────────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarImportar"
  [modal]="true"
  [closable]="!importando"
  header="Importar la hoja CENTRAL"
  styleClass="central-import-dialog"
  [style]="{ width: '640px' }"
  [breakpoints]="{ '720px': '95vw' }"
>
  <div class="ct-form">
    <p class="ct-form-note">
      Sube el libro de Excel de Contabilidad. Primero se <b>lee sin guardar nada</b> y te dice qué va a entrar y qué no; solo al confirmar
      se crean o actualizan las facturas. Volver a subir la misma hoja actualiza, no duplica.
    </p>

    <label for="ct-hoja-archivo">Archivo (.xlsx)</label>
    <input id="ct-hoja-archivo" type="file" accept=".xlsx" (change)="elegirHoja($event)" />

    <label for="ct-hoja-nombre">Pestaña <span class="ct-opt">(opcional)</span></label>
    <input
      id="ct-hoja-nombre"
      pInputText
      [(ngModel)]="nombreHoja"
      (ngModelChange)="vistaPrevia = null"
      placeholder="CENTRAL"
      autocomplete="off"
    />
    <small class="ct-form-hint">Si la dejas vacía se lee la pestaña que se llama CENTRAL.</small>

    <div class="ct-preview" *ngIf="vistaPrevia">
      <p class="ct-form-lead">
        Pestaña <b>{{ vistaPrevia.sheetName || '—' }}</b> · {{ vistaPrevia.totals.readRows }} renglones leídos
      </p>
      <p class="ct-nodeps" *ngIf="!vistaPrevia.totals.readRows">
        No se leyó ningún renglón. Revisa que la pestaña sea la de CENTRAL y que conserve sus encabezados.
      </p>
      <div class="ct-preview-kpis" *ngIf="vistaPrevia.totals.readRows">
        <span
          ><b class="ct-ok">{{ vistaPrevia.totals.created }}</b> nuevas</span
        >
        <span
          ><b>{{ vistaPrevia.totals.updated }}</b> se actualizan</span
        >
        <span
          ><b [class.ct-pend]="vistaPrevia.totals.skipped">{{ vistaPrevia.totals.skipped }}</b> no entran</span
        >
      </div>
      <div class="ct-preview-list" *ngIf="omitidas.length">
        <div class="ct-preview-row" *ngFor="let f of omitidas">
          <span class="ct-mono">{{ f.invoiceFolio || 'renglón ' + f.rowNumber }}</span>
          <span class="ct-client">{{ f.clientName || '—' }}</span>
          <span class="ct-preview-why">{{ f.reason }}</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="importando" (click)="mostrarImportar = false"></button>
    <button
      *ngIf="!vistaPrevia"
      pButton
      type="button"
      label="Leer la hoja"
      icon="fa-solid fa-magnifying-glass"
      [loading]="leyendo"
      [disabled]="!archivoHoja || leyendo"
      (click)="leerHoja()"
    ></button>
    <button
      *ngIf="vistaPrevia"
      pButton
      type="button"
      [label]="'Importar ' + (vistaPrevia.totals.created + vistaPrevia.totals.updated) + ' facturas'"
      icon="fa-solid fa-check"
      [loading]="importando"
      [disabled]="importando || !(vistaPrevia.totals.created + vistaPrevia.totals.updated)"
      (click)="importarHoja()"
    ></button>
  </ng-template>
</p-dialog>

<p-toast position="top-right"></p-toast>
